import { render, staticRenderFns } from "./avoidLogin.vue?vue&type=template&id=67344d46&scoped=true&"
import script from "./avoidLogin.vue?vue&type=script&lang=js&"
export * from "./avoidLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67344d46",
  null
  
)

export default component.exports